<script>
import { DatePicker } from 'ant-design-vue'
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN'
import moment from 'moment'
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    value: {
      type: Object,
      default: () => [],
    },
    getValue: {
      type: Function,
      default: null,
    },
    setValue: {
      type: Function,
      default: null,
    },
  },
  methods: {
    getData() {
      if (this.item.keys) {
        return this.item.keys.map((e) => {
          const value = this.getValue({ key: e })
          if (value) {
            return moment(value)
          } else {
            return value
          }
        })
      } else {
        return this.value
      }
    },
    onChange(times) {
      if (this.item.onChange) {
        this.item.onChange(times)
      }
      if (this.item.keys) {
        if (times.length > 0) {
          this.item.keys.forEach((e, i) => {
            if (this.item.showTime) {
              this.setValue(e, moment(times[i]).format('YYYY-MM-DD HH:mm:ss'))
            } else if (this.item.showTimeNo) {
              this.setValue(e, moment(times[i]).format('YYYY-MM-DD 00:00:00'))
            } else {
              this.setValue(e, moment(times[i]).format('YYYY-MM-DD'))
            }
          })
        } else {
          // times 是空，点了取消
          this.$emit('rangeClear', this.item.keys)
        }
      } else {
        this.$emit('change', times)
      }
    },
  },
  render() {
    const onDisabledDate = (current) => {
      if (this.item.canUseDate) {
        const value = moment(current.format('YYYY-MM-DD')).valueOf() + ''
        if (this.item.canUseDate.includes(value)) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    }
    return (
      <DatePicker.RangePicker
        showTime={this.item.showTime}
        disabled={this.item.disabled}
        ranges={this.item.ranges ? this.item.ranges : {}}
        allowClear={this.item.allowClear}
        onChange={this.onChange}
        disabledDate={onDisabledDate}
        value={this.getData()}
        style={{ width: '100%' }}
        placeholder={['开始日期', '结束日期']}
        locale={locale}
      ></DatePicker.RangePicker>
    )
  },
}
</script>
